/* Currency / share formatters used by every Finance panel.
   Kept dumb on purpose — the page is dollar-denominated in the
   Loveable mock and that's what the screenshots show. Real
   data will switch to JPY (¥) when the backend lands and the
   ja-JP locale will format the numbers automatically. */

export function fmtUsd(value: number): string {
  return `$${value.toLocaleString('en-US')}`;
}

/** "$48,320" */
export function fmtUsdNoCents(value: number): string {
  return `$${Math.round(value).toLocaleString('en-US')}`;
}

/** "$12.4M" / "$8.76M" — 1 decimal under 10, 2 decimals otherwise (matches Loveable). */
export function fmtUsdMillions(value: number, decimals = 2): string {
  return `$${(value / 1_000_000).toFixed(decimals)}M`;
}

/** "$120.0K" / "$32.0K" — always 1 decimal. */
export function fmtUsdThousands(value: number): string {
  return `$${(value / 1000).toFixed(1)}K`;
}

/** "$2400K" — integer thousands, no decimal, no thousand-separator
   (Budget tab convention — matches the Loveable reference). */
export function fmtUsdThousandsInt(value: number): string {
  return `$${Math.round(value / 1000)}K`;
}

/** Signed variance: "$-120K" / "+$240K" / "$-2075K". No separator —
   matches the Loveable reference. */
export function fmtSignedThousands(value: number): string {
  const abs = Math.abs(value);
  if (value < 0) return `$-${abs}K`;
  return `+$${abs}K`;
}

/** Signed delta % used by the floor heatmap: "+8%" / "+19%". */
export function fmtSignedPct(value: number): string {
  return `${value >= 0 ? '+' : ''}${value}%`;
}

/** "91.9%" / "107.0%" — 1 decimal. */
export function fmtPct1(value: number): string {
  return `${value.toFixed(1)}%`;
}
